import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BillModel } from '@data-layer/models/payments';
import { GoogleAnalyticsService } from '@services/google-analytics.service';
import { enumPaymentState } from '@data-layer/enums/payments';

@Component({
  selector: 'es-payment-button',
  templateUrl: './es-payment-button.component.html',
  styleUrls: ['./es-payment-button.component.scss'],
})
export class EsPaymentButtonComponent implements OnInit {
  @Input() public referenceNumber: string;
  @Input() public coupon: string;
  @Input() public id: string = 'payment-button-container';
  @Output() public cancelPayment: EventEmitter<any> = new EventEmitter<any>();
  @Output() public successPayment: EventEmitter<{
    state: enumPaymentState;
    bill: BillModel;
  }> = new EventEmitter<{
    state: enumPaymentState;
    bill: BillModel;
  }>();
  @Output() public errorPayment: EventEmitter<any> = new EventEmitter<any>();
  @Output() public errorCustomPayment: EventEmitter<any> = new EventEmitter<any>();
  @Output() public addToCard: EventEmitter<any> = new EventEmitter<any>();

  constructor(private ga: GoogleAnalyticsService) {}

  public ngOnInit(): void {}

  public onSuccessPayment(data: { state: enumPaymentState; bill: BillModel }) {
    this.successPayment.emit(data);
  }

  public onErrorCustomPayment(error) {
    this.errorCustomPayment.emit(error);
  }

  public onErrorCallback(error) {
    this.errorPayment.emit(error);
  }

  public onCancelCallback(data) {
    this.cancelPayment.emit(data);
  }

  public onAddToCard() {
    this.addToCard.emit();
  }
}
